import { Check } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'
import { trackMxEvent } from '@/utils/mixpanel'
import useAuth from '@/hooks/useAuth'
import { Button } from '@/components/ui/button'

export default function RegisterPro() {
  const { currentUser } = useAuth()
  if (currentUser?.isProfessional) {
    return null
  }

  return (
    <div className="relative w-full pt-10 md:pt-0">
      <div className="container relative overflow-visible">
        <div className="absolute inset-0 select-none px-5">
          <Image
            className="h-full w-full rounded-2xl object-cover"
            src="/images/home/v2/banner-bg.png"
            width="1084"
            height="373"
            alt=""
          />
        </div>
        <div className="absolute -inset-x-6 -top-10 aspect-video translate-x-[-8%] select-none md:inset-x-0 md:left-auto md:-top-10 md:bottom-0 md:translate-x-8">
          <Image
            className="h-full w-full"
            src="/images/home/v2/pro-obj.png"
            width="2069"
            height="1319"
            alt=""
          />
        </div>
        <div className="relative mx-8 pt-[calc(100vw*0.3)] pb-10 text-center md:p-10 md:text-left lg:py-15">
          <h2 className="mb-3 text-lg text-white md:text-3xl">
            クリエイターとして参加しませんか？
          </h2>
          <p className="text-left font-semibold text-white/80 md:mb-8">
            あなたの才能を、
            <br className="md:hidden" />
            必要としている人がいます。
          </p>
          <div className="mb-8 flex flex-col space-y-1 text-white">
            <div className="flex items-center space-x-2">
              <Check className="text-extent" width={16} height={16} />
              <p className="mb-0">
                公開依頼へ自由に提案できる
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <Check className="text-extent" width={16} height={16} />
              <p className="mb-0">
                直接依頼が受けられる
              </p>
            </div>
            <div className="flex items-center space-x-2">
              <Check className="text-extent" width={16} height={16} />
              <p className="mb-0">
                あなたのショーケースを持てる
              </p>
            </div>
          </div>
          <Button variant="special" size="xl" asChild>
            <Link
              href="/for/pro"
              onClick={() => trackMxEvent('Home About Pro Click')}
            >
              クリエイター登録
            </Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
